export default "__VITE_ASSET__Ns5cyho9__"